import React, { useCallback, useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { DrawerComponent } from 'components/Drawer';
import { api } from 'services/api';
import loadingSmall from 'assets/image/loading-small.gif';
import * as S from './styles';
import CardDrawer from './components/CardDrawer';
import {
  DocumentSignature,
  DownloadIcon,
  KenloLiaIcon,
} from 'components/Icons';
import PencilLIA from 'components/Icons/PincelLIA';
import ShapeLIA from 'components/Icons/ShapeLIA';
import Chat from 'components/Icons/Chat';
import Sparkle from 'components/Icons/Sparkle';
import NoteCheck from 'components/Icons/NoteCheck';
import moment from 'moment';
import 'moment/locale/pt-br';
import { theme } from 'styles/theme';
import { ToolTip } from 'components/ToolTip';
import { InvoiceStatus } from 'components/InvoiceStatus';
import Hands from 'components/Icons/hands';
interface IConsumptionDetails {
  closeDrawer: () => void;
  idConsumption: string | undefined;
  indicator: any;
  typeProduct: string;
  exceedingEnvelopes: any;
}
// Enum NumberTypeTransactionDebit
enum NumberTypeTransactionDebit {
  ZERA_FRANQUIA = 1,
  QUALIFIER = 2,
  EXPIRATION = 3,
  REVERSE = 4,
  SIGNATURE = 5,
  FACIAL_RECOGNITION = 6,
  FACIAL_RECOGNITION_SIGNATURE = 7,
  PROPERTY_DESCRIPTION = 8,
  PICTURE_EDITING = 9,
  CHATBOT = 10,
  POST = 11,
  VIDEO_GENERATION = 12,
  LANDING_PAGE = 13,
}

// Função para mapear o tipo de transação para a categoria
const mapTransactionTypeToCategory = (
  typeTransaction: number | string | undefined,
): 'SDR' | 'Editor' | 'Studio' | 'Omnichannel' | 'Oráculo' | 'Ficha limpa' | undefined => {
  const type =
    typeof typeTransaction === 'string'
      ? parseInt(typeTransaction)
      : typeTransaction;

  if (type === NumberTypeTransactionDebit.CHATBOT) {
    return 'SDR';
  }
  if (
    type === NumberTypeTransactionDebit.PROPERTY_DESCRIPTION ||
    type === NumberTypeTransactionDebit.PICTURE_EDITING
  ) {
    return 'Editor';
  }
  if (type === NumberTypeTransactionDebit.VIDEO_GENERATION) {
    return 'Studio';
  }
  if (type === NumberTypeTransactionDebit.POST) {
    return 'Omnichannel';
  }
  if (type === NumberTypeTransactionDebit.LANDING_PAGE) {
    return 'Ficha limpa';
  }

  return undefined;
};

const iconColor = '#404040';

const categories = [
  {
    name: 'SDR',
    color: '#B5E4FF',
    key: 'qtd_sdr',
    icon: <Chat color={iconColor} />,
    label: 'SDR',
  },
  {
    name: 'Omnichannel',
    color: '#7CAEF1',
    key: 'qtd_posts_lia',
    icon: <DocumentSignature color={iconColor} />,
    label: 'Omnichannel',
  },
  {
    name: 'Oráculo',
    color: '#1F3A8A',
    key: 'qtd_oraculo',
    icon: <Sparkle color={iconColor} width='24' height='24' />,
    label: 'Oráculo',
  },
  {
    name: 'Editor',
    color: '#514180',
    key: 'qtd_editor',
    icon: <PencilLIA color={iconColor} />,
    label: 'Editor',
  },
  {
    name: 'Studio',
    color: '#C876F2',
    key: 'qtd_videos_lia',
    icon: <ShapeLIA color={iconColor} />,
    label: 'Studio',
  },
  {
    name: 'Ficha limpa',
    color: '#F1C0FF',
    key: 'qtd_ficha_limpa',
    icon: <NoteCheck color={iconColor} />,
    label: 'Ficha limpa',
  },
];
const ConsumptionDetails = ({
  closeDrawer,
  idConsumption,
  indicator,
  typeProduct,
  exceedingEnvelopes,
}: IConsumptionDetails) => {
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [isExporting, setIsExporting] = useState(false);
  const [history, setHistory] = useState<any[]>([]);
  const fetchDataDailyQualification = async () => {
    setIsLoading(true);
    const startDate = moment(
      `${indicator.ano}-${indicator.mes}-01`,
      'YYYY-MM-DD',
    ).format('YYYY-MM-DD');
    let endDate;

    const currentMonth = moment().month() + 1; // Mês atual (1 baseado)
    const currentYear = moment().year(); // Ano atual

    // Verifica se o mês indicado é o mesmo do mês atual
    if (indicator.mes === currentMonth && indicator.ano === currentYear) {
      endDate = moment().format('YYYY-MM-DD'); // Usa o dia de hoje
    } else {
      // Caso contrário, usa o último dia do mês indicado
      endDate = moment(`${indicator.ano}-${indicator.mes}-01`)
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    try {
      const { data } = await api.get(
        `qualifier/movto/debit/${idConsumption}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&limit=${10}&type_product=${typeProduct}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      setHistory(prevState => {
        // Filtra os novos dados para garantir que não haja objetos duplicados
        const filteredData = data.data.filter(
          (newItem: any) =>
            !prevState.some(
              existingItem =>
                JSON.stringify(existingItem) === JSON.stringify(newItem),
            ),
        );

        return [...prevState, ...filteredData];
      });

      setTotalPages(data.pagination.pages);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchAllDataForExport = async () => {
    const startDate = moment(
      `${indicator.ano}-${indicator.mes}-01`,
      'YYYY-MM-DD',
    ).format('YYYY-MM-DD');
    let endDate;

    const currentMonth = moment().month() + 1; // Mês atual (1 baseado)
    const currentYear = moment().year(); // Ano atual

    // Verifica se o mês indicado é o mesmo do mês atual
    if (indicator.mes === currentMonth && indicator.ano === currentYear) {
      endDate = moment().format('YYYY-MM-DD'); // Usa o dia de hoje
    } else {
      // Caso contrário, usa o último dia do mês indicado
      endDate = moment(`${indicator.ano}-${indicator.mes}-01`)
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    try {
      const { data } = await api.get(
        `qualifier/movto/debit/${idConsumption}/export?startDate=${startDate}&endDate=${endDate}&type_product=${typeProduct}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      return data.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  };
  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const allData = await fetchAllDataForExport();

      if (allData.length === 0) {
        alert('Não há dados para exportar');
        return;
      }

      // Preparar os dados para o Excel
      const excelData = allData.map((item: any) => ({
        'Data de uso': moment(item.date).format('DD/MM/YYYY HH:mm'),
        Funcionalidade: item.type_transaction_description || '',
        Usuário: item.name_broker || '',
        'Consumo de koins': item.value * -1 || 0,
      }));

      // Criar workbook e worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Definir largura das colunas
      const columnWidths = [
        { wch: 25 }, // Data de uso
        { wch: 20 }, // Funcionalidade
        { wch: 15 }, // Usuário
        { wch: 18 }, // Consumo de koins
      ];
      worksheet['!cols'] = columnWidths;

      // Adicionar worksheet ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Consumo de koins');

      // Gerar nome do arquivo
      const monthName =
        moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
          .format('MMMM')
          .charAt(0)
          .toUpperCase() +
        moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
          .format('MMMM')
          .slice(1);

      const fileName = `Consumo_LIA_${monthName}_${indicator?.ano}.xlsx`;

      // Fazer download do arquivo
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      alert('Erro ao exportar dados. Tente novamente.');
    } finally {
      setIsExporting(false);
    }
  };
  useEffect(() => {
    fetchDataDailyQualification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indicator, idConsumption, currentPage]);

  const Loader = () => {
    return (
      <S.Loader>
        <img src={loadingSmall} />
      </S.Loader>
    );
  };

  const [nextPageDiv, setNextPageDiv] = useState<HTMLDivElement | null>(null);
  const showMoreHistory = () => {
    setCurrentPage(indicatorsPerPage => indicatorsPerPage + 1);
  };
  const nextPageDivCallback = useCallback((node: HTMLDivElement | null) => {
    setNextPageDiv(node);
  }, []);

  useEffect(() => {
    if (!nextPageDiv) return;

    const observer = new IntersectionObserver(
      entries => {
        const target = entries[0];
        if (target.isIntersecting && currentPage < totalPages) {
          showMoreHistory();
        }
      },
      {
        root: null,
        rootMargin: '20px',
        threshold: 0.1,
      },
    );

    observer.observe(nextPageDiv);

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextPageDiv]);

  return (
    <DrawerComponent
      open
      size='default'
      // className={styles.drawer}
      onCompleteClose={closeDrawer}
      titleClose={'Consumo mensal'}
    >
      {isLoading && currentPage === 1 ? (
        <Loader />
      ) : (
        <>
          <S.WrapperInvoiceDetail>
            <span>
              {moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
                .format('MMMM')
                .charAt(0)
                .toUpperCase() +
                moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
                  .format('MMMM')
                  .slice(1)}{' '}
              de{' '}
              {moment(
                `${indicator?.ano}-${indicator?.mes}-01`,
                'YYYY-MM-DD',
              ).format('YYYY')}
            </span>
          </S.WrapperInvoiceDetail>
          <S.ContentDetails>
            <S.Box>
              <S.TextAside
                fontSize='16'
                fontWeight='700'
                style={{ marginBottom: '16px' }}
              >
                {indicator?.qtd_total_lia || 0} koins
              </S.TextAside>
              {(() => {
                const total = indicator?.qtd_total_lia || 0;
                const segments = categories.map(cat => {
                  const value = indicator?.[cat.key] || 0;
                  return {
                    ...cat,
                    value,
                    percentage: total > 0 ? (value / total) * 100 : 0,
                  };
                });

                return (
                  <S.CategoryList>
                    {segments.map(segment => (
                      <S.CategoryRow key={segment.key}>
                        <S.CategoryInfo>
                          <S.CategoryRow
                            key={segment.key}
                            style={{ justifyContent: 'space-between' }}
                          >
                            <S.CategoryRow style={{ width: 'fit-content' }}>
                              <S.CategoryIconWrapper>
                                {segment.icon}
                              </S.CategoryIconWrapper>
                              <S.CategoryName>
                                {segment.name} {Math.round(segment.percentage)}%
                              </S.CategoryName>
                            </S.CategoryRow>
                            <S.CategoryValue>
                              {segment.value}{' '}
                              {segment.value !== 1
                                ? segment.label
                                : segment.label
                                    .replace('s', '')
                                    .replace('es', '')}
                            </S.CategoryValue>
                          </S.CategoryRow>
                          <S.CategoryBarContainer>
                            <S.CategoryBar
                              width={segment.percentage}
                              color={segment.color}
                            />
                          </S.CategoryBarContainer>
                        </S.CategoryInfo>
                      </S.CategoryRow>
                    ))}
                  </S.CategoryList>
                );
              })()}
            </S.Box>
            <S.TextAside
              fontSize='16'
              fontWeight='700'
              style={{ marginBottom: '16px' }}
            >
              Saldo recebido
            </S.TextAside>
            <S.Box>
              <div
                style={{
                  display: 'flex',
                  gap: '16px',
                  justifyContent: 'space-between',
                }}
              >
                {' '}
                <S.TextAside fontSize='16' fontWeight='500'>
                  Koins do plano
                </S.TextAside>{' '}
                <S.TextAside fontSize='16' fontWeight='700'>
                  <InvoiceStatus
                    status={'venda'}
                    text={indicator?.qtd_creditos_recebidos}
                    icon={<KenloLiaIcon size={16} />}
                    colortText={theme.colors.neutral.neutral120}
                    fontWeight='500'
                  />
                </S.TextAside>
              </div>
              {(indicator.mes === moment().month() + 1
                ? exceedingEnvelopes
                : indicator?.qtd_debitos_negativos) > 0 ? (
                <>
                  <hr style={{ margin: '16px -24px' }} />
                  <div
                    style={{
                      display: 'flex',
                      gap: '16px',
                      justifyContent: 'space-between',
                    }}
                  >
                    {' '}
                    <S.TextAside fontSize='16' fontWeight='500'>
                      Koins adicionados
                    </S.TextAside>{' '}
                    <S.TextAside fontSize='16' fontWeight='700'>
                      <InvoiceStatus
                        status={'venda'}
                        text={
                          indicator.mes === moment().month() + 1
                            ? exceedingEnvelopes
                            : indicator?.qtd_debitos_negativos
                        }
                        icon={<KenloLiaIcon size={16} />}
                        colortText={theme.colors.neutral.neutral120}
                        fontWeight='500'
                      />
                    </S.TextAside>
                  </div>
                </>
              ) : (
                <></>
              )}
            </S.Box>
            <div
              style={{
                display: 'flex',
                gap: '16px',
                justifyContent: 'space-between',
                marginBottom: '16px',
              }}
            >
              <S.TextAside fontSize='16' fontWeight='700'>
                Koins utilizados
              </S.TextAside>
              <span
                onClick={
                  isExporting || history.length <= 0 ? undefined : exportToExcel
                }
                style={{
                  color:
                    isExporting || history.length <= 0
                      ? theme.colors.neutral.neutral50
                      : theme.colors.primary50,
                  cursor:
                    isExporting || history.length <= 0
                      ? 'not-allowed'
                      : 'pointer',
                  opacity: isExporting || history.length <= 0 ? 0.6 : 1,
                  pointerEvents:
                    isExporting || history.length <= 0 ? 'none' : 'auto',
                  fontSize: '16px !important',
                }}
              >
                <ToolTip
                  right='2rem'
                  height='3rem'
                  content={
                    isExporting
                      ? 'Download em andamento, aguarde...'
                      : 'Clique para fazer o download dos dados.'
                  }
                  icon={
                    <div style={{ marginLeft: '1rem' }}>
                      {isExporting ? <S.LoadingSpinner /> : <DownloadIcon />}
                    </div>
                  }
                  text={isExporting ? 'Exportando...' : 'Exportar'}
                />
              </span>
            </div>

            <S.Box>
              {history.length > 0 ? (
                history.map((el, index) => {
                  const category =
                    mapTransactionTypeToCategory(
                      el?.id_transaction_debit_type,
                    ) ||
                    el?.type ||
                    el?.category;
                  return (
                    <>
                      <CardDrawer
                        key={el?.id_debit}
                        name={el?.signature_name}
                        status={el?.signature_status}
                        broker={el?.name_broker}
                        date={el?.date}
                        value={el?.value}
                        type={category}
                        clientName={el?.name_client || el?.client_name}
                        secondaryText={el?.type_transaction_description}
                        actionType={el?.use_description}
                      />

                      {index !== history.length - 1 && (
                        <hr style={{ margin: '16px -24px' }} />
                      )}
                    </>
                  );
                })
              ) : (
                <S.NotLeads>
                  <Hands />
                  <div>
                    <S.TitlePerfomace
                      color={theme.colors.neutral.neutral120}
                      fontWeight={600}
                      fontSize='2rem'
                      style={{ marginBottom: '8px' }}
                    >
                      Nenhum koins utilizado esse mês
                    </S.TitlePerfomace>
                    <S.SubtitlePerfomace
                      color={theme.colors.neutral.neutral120}
                      fontWeight={500}
                    >
                      Utilize os recursos da LIA para consumir koins.
                    </S.SubtitlePerfomace>
                  </div>
                </S.NotLeads>
              )}
            </S.Box>
            <div ref={nextPageDivCallback} />
          </S.ContentDetails>
        </>
      )}
    </DrawerComponent>
  );
};
export default ConsumptionDetails;
